import { useHistory } from 'react-router'
import { useCallback } from 'react'
import { LocationState } from 'history'

import { encodeOccurrenceFromEvent } from '../../../helpers/encodeOccurrence'
import { Opportunity } from '../../../interfaces'
import { navigateWithStack } from 'core/navigation/navigationStack'

export const useViewEventDetails = () => {
  const history = useHistory()

  return useCallback(
    (event: Opportunity, locationState?: LocationState, backLabel = 'Events') => {
      const encodedInstance = encodeOccurrenceFromEvent(event)
      const organizationId = event.organization.id

      navigateWithStack(history, `/events/${encodedInstance}/${organizationId}`, backLabel, locationState)
    },
    [history],
  )
}
